module.exports = __webpack_public_path__ + "img/round1.8d1af243.gif";